import Work1 from '../../assets/work1.jpg';
import Work2 from '../../assets/work2.jpg';
import Work3 from '../../assets/work3.png';
import Work4 from '../../assets/work4.jpg';
import Work6 from '../../assets/work6.jpg';
import Work7 from '../../assets/leici.png';
import Work8 from '../../assets/sanblasthumbail.png'

const Menu = [
    {
      id: 1,
      image: Work1,
      title: "Social Media | Circusbar",
      category: "Social Media",
      link: "https://www.behance.net/gallery/152915763/Social-Media-CircusBar-Xela",
    },

    {
      id: 2,
      image: Work2,
      title: "Social Media | La Bodeguita",
      category: "Social Media",
      link: "https://www.behance.net/gallery/152971455/Social-Media-La-Bodeguita-Xela",
    },

    {
      id: 3,
      image: Work3,
      title: "Social Media | BurgerShop",
      category: "Social Media",
      link: "https://www.behance.net/gallery/155392177/Social-Media-2022",
    },

    {
      id: 4,
      image: Work4,
      title: "Social Media | El Pinche Xela",
      category: "Social Media",
      link: "https://www.behance.net/gallery/152915137/Social-Media-El-Pinche-Xela",
    },
    {
      id: 6,
      image: Work7,
      title: "Branding | LEICI",
      category: "Branding",
      link:"https://www.behance.net/gallery/160218749/Leici-Branding",
    },
    {
      id: 7,
      image: Work6,
      title: "Branding | Taquisimo",
      category: "Branding",
      link: "https://www.behance.net/gallery/116716551/Manual-de-Identidad-Taquisimo",
    },
    {
      id: 8,
      image: Work8,
      title: "Branding | SanBlas",
      category: "Branding",
      link: "https://www.behance.net/gallery/161258477/San-Blas-Branding",
    },
  ];


  export default Menu;